import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function LeaveAdmin() {
  const [rows, setRows] = useState([]);
  const [filter, setFilter] = useState("PENDING");

  async function load() {
    const q = filter === "ALL" ? "" : `?status=${filter}`;
    const { data } = await api.get(`/leave${q}`);
    setRows(data);
  }
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [filter]);

  async function decide(id, status) {
    try { await api.post(`/leave/${id}/decision`, { status, remarks: "" }); toast.success(status); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  }

  return (
    <div className="p-6 md:p-10">
      <div className="flex items-end justify-between flex-wrap gap-3 mb-6">
        <div>
          <p className="text-xs tracking-[0.3em] uppercase text-[#E50914] mb-2">Time-off</p>
          <h1 className="font-display text-3xl sm:text-4xl tracking-tight">Leave Requests</h1>
        </div>
        <div className="flex gap-2">
          {["PENDING","APPROVED","REJECTED","ALL"].map((s) => (
            <button key={s} onClick={()=>setFilter(s)} data-testid={`leave-filter-${s}`}
                    className={`text-xs uppercase tracking-widest px-3 py-2 border rounded-md
                      ${filter===s ? "border-[#E50914] text-white bg-[#E50914]/10" : "border-[#2D2D35] text-zinc-400 hover:text-white"}`}>{s}</button>
          ))}
        </div>
      </div>
      <div className="bg-[#16161C] border border-[#2D2D35] rounded-md overflow-hidden">
        <table className="w-full" data-testid="leave-table">
          <thead>
            <tr className="text-[10px] uppercase tracking-widest text-zinc-500 border-b border-[#2D2D35]">
              <th className="text-left p-3">Employee</th>
              <th className="text-left p-3">Type</th>
              <th className="text-left p-3">From</th>
              <th className="text-left p-3">To</th>
              <th className="text-left p-3">Reason</th>
              <th className="text-right p-3">Status</th>
              <th className="text-right p-3"></th>
            </tr>
          </thead>
          <tbody className="text-sm">
            {rows.map((r) => (
              <tr key={r.id} className="border-b border-[#2D2D35]/60 hover:bg-[#1C1C24]">
                <td className="p-3"><div>{r.employee_name}</div><div className="text-[10px] text-zinc-500 font-mono">{r.employee_id}</div></td>
                <td className="p-3 text-xs"><span className="px-2 py-1 rounded bg-[#0D0D10] border border-[#2D2D35]">{r.leave_type}</span></td>
                <td className="p-3 font-mono text-xs">{r.from_date}</td>
                <td className="p-3 font-mono text-xs">{r.to_date}</td>
                <td className="p-3 text-xs text-zinc-300 max-w-sm truncate">{r.reason}</td>
                <td className="p-3 text-right text-xs">{r.status}</td>
                <td className="p-3 text-right">
                  {r.status === "PENDING" && (
                    <div className="flex gap-2 justify-end">
                      <Button size="sm" onClick={()=>decide(r.id, "APPROVED")} data-testid={`leave-approve-${r.id}`}
                              className="bg-[#22C55E]/15 hover:bg-[#22C55E]/25 text-[#22C55E] border border-[#22C55E]/30">Approve</Button>
                      <Button size="sm" onClick={()=>decide(r.id, "REJECTED")} data-testid={`leave-reject-${r.id}`}
                              className="bg-[#FF3B30]/15 hover:bg-[#FF3B30]/25 text-[#FF3B30] border border-[#FF3B30]/30">Reject</Button>
                    </div>
                  )}
                </td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan="7" className="text-center text-zinc-500 p-8 text-sm">No leave requests.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
